import { formatNumber, ResourceStatus } from "@quortex/front-common"
import type { FC } from "react"
import type { OttEndpointRow } from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/types"

type Props = {
  row: OttEndpointRow
}

const OttEndpointInputHeader: FC<Props> = ({ row }) => (
  <div className="flex h-full items-center whitespace-nowrap text-sm">
    <div className="tablet:flex grow">
      <div className="flex-1 px-sm py-xs font-medium" data-testid="input-name">
        {row.inputName}
      </div>
      <div className="flex-1 px-sm py-xs" data-testid="input-ott-endpoint-number">
        {formatNumber(row.endpointsCount)} endpoint
        {row.endpointsCount > 1 && "s"}
      </div>
    </div>

    <div className="w-[13.5rem] px-sm py-xs">
      {row.status && <ResourceStatus messageDetail={[]} status={row.status} />}
    </div>
  </div>
)

export default OttEndpointInputHeader
